import { Tooltip } from '@shared/components/popover/tooltip';
import { minQOHThreshold, type Product } from '../../../data/product';
import { defineColumn, type StrictColumnDef } from '../../tanstack-table/column';

export const Reorder: StrictColumnDef<Product> = defineColumn<Product>({
  id: 'Reorder',
  minWidth: 75,
  accessorFn: (product) => {
    if (product.disabled) {
      return 'DISABLED';
    }

    if (product.auto_disabled) {
      return 'AUTO_DSBL';
    }

    if (product.min_qoh && product.min_qoh > 0) {
      return 'MIN_QOH';
    }

    return '';
  },
  cell: ({ item: product, value }) => {
    if (product.disabled) {
      return (
        <Tooltip content="You disabled this product.">
          <span className="has-tooltip">{value}</span>
        </Tooltip>
      );
    }

    if (product.auto_disabled) {
      return (
        <Tooltip content="This hasn't been selling. Suggestions resume automatically once sales pick up.">
          <span className="has-tooltip">{value}</span>
        </Tooltip>
      );
    }

    if (product.min_qoh && product.min_qoh > 0) {
      return (
        <Tooltip content={`You set a minimum quantity on hand of ${minQOHThreshold(product)}.`}>
          <span className="has-tooltip">{value}</span>
        </Tooltip>
      );
    }

    return <span>{value}</span>;
  },
  gloss: 'Whether Orderbot is suggesting this for reorder. If not, hover the cell to see why.',
});
